module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "rgba(0,0,0,0.2)"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "container pt-2 pb-2"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "to": "/seja-um-parceiro"
    }
  }, [_c('b', [_vm._v("Seja um Parceiro")])])], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "mt-1",
    staticStyle: {
      "color": "#FFF",
      "font-size": "70px",
      "font-weight": "900"
    }
  }, [_vm._v("\n            É rápido"), _c('br'), _vm._v("\n            é fácil,"), _c('br'), _vm._v("\n            é pra você!"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container pt-1"
  }, [_c('div', {
    staticClass: "row pb-2 pt-2"
  }, [_c('div', {
    staticClass: "col text-left"
  }, [_c('h2', {
    staticClass: "info-text"
  }, [_vm._v("\n                        Sabemos o caminho para o sucesso e queremos levar você!\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col text-justify"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("\n                        Você, empreendedor, gostaria de expandir seu mix de produtos, mas não consegue comprar direto com a indústria, por motivo de baixo valor disponível para compra ou até mesmo por não necessitar montar grandes estoques?\n                        "), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#c70000",
      "font-weight": "900"
    }
  }, [_vm._v("Saiba que temos uma ótima oportunidade de negócio para você!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5702ac94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/pages/Home.vue
// module id = 872
// module chunks = 0